import { Button, Modal, message, Typography, Input } from "antd";
import { isSupportManager } from "../../../helpers/genericHelper";
import LoaderComponent from "../../Loader";
import API from "../../../services/API";
import { useState } from "react";

const { Link } = Typography;

function DocumentVerificationLink({ userId, modalLoading, showModalLoading, reloadData }) {
  const [modalVisible, setModalVisible] = useState(false);
  const [verificationData, setVerificationData] = useState({});
  const [requestEmail, setRequestEmail] = useState('');
  const [zendeskTicket, setZendeskTicket] = useState('');

  const createDocumentVerificationLink = async () => {
    try {
      showModalLoading(true);
      const response = await API.createDocumentVerificationLink(userId, requestEmail, zendeskTicket);
      setVerificationData(response.documentVerification);
      message.success("Document verification link generated successfully");
      showModalLoading(false);
    } catch (e) {
      message.error("Unable to generate document verification link" + e.toString());
      console.error(e);
      showModalLoading(false);
      setModalVisible(false);
    }
  };

  return (
    <>
      <Button
        className="card-bottom-buttons"
        type="primary"
        onClick={() => setModalVisible(true)}>
        Get Document Verification Link
      </Button>

      <Modal
        title={Object.keys(verificationData).length === 0 ? "Confirm Document Verification Link" : "Document Verification Link"}
        centered
        open={modalVisible}
        onOk={Object.keys(verificationData).length === 0 ? createDocumentVerificationLink : null}
        onCancel={() => {
          setModalVisible(false);
          // Refresh on close, because refreshing earlier would close the new link
          if (Object.keys(verificationData).length > 0 && reloadData) reloadData();
        }}
        closable={true}
        className="confirm-modal"
        okText="Generate Link"
        cancelText="Close"
        width={700}
        okButtonProps={{ hidden: Object.keys(verificationData).length > 0 }}
        destroyOnClose={false}
      >
        {Object.keys(verificationData).length === 0 ? (
          <>
            <p>Are you sure you want to generate a document verification link for this user?</p>
            <p><strong>Email:</strong> <Input value={requestEmail} onChange={(e) => setRequestEmail(e.target.value)} placeholder="Enter email" /></p>
            <Typography.Text type="secondary" style={{ display: 'block', marginBottom: '20px' }}>Enter the email used by the customer to request verification for tracking purposes</Typography.Text>
            <p><strong>Zendesk Ticket Number:</strong> <Input value={zendeskTicket} onChange={(e) => setZendeskTicket(e.target.value)} placeholder="Enter ticket number" /></p>
            {modalLoading && <LoaderComponent />}
          </>
        ) : (
          <div>
            <p><strong>ID:</strong> {verificationData.id}</p>
            <p><strong>Status:</strong> {verificationData.status}</p>
            <p><strong>URL: </strong><Link copyable href={verificationData.url} target="_blank" rel="noopener noreferrer">{verificationData.url}</Link></p>
            <p><strong>Expires:</strong> {verificationData.expires}</p>
            <p><strong>Context:</strong> {verificationData.context}</p>
          </div>
        )}
      </Modal>
    </>
  );
}

export default DocumentVerificationLink;